

















































import Vue from "vue";
import { Explanation } from "../utility/explanation";

export interface ITimeEstimate {
    route: number;
    direct: number;
}

export default Vue.extend({
    name: "route-summary",
    props: ["explanation", "estimate"],
    data(): {} {
        return {};
    },
    computed: {
        expl(): null | Explanation {
            return this.explanation;
        },

        est(): null | ITimeEstimate {
            return this.estimate;
        },

        routeTimeFormatted(): string {
            return Math.round((this.est || { route: 0, direct: 0 }).route).toLocaleString();
        },

        directTimeFormatted(): string {
            return Math.round((this.est || { route: 0, direct: 0 }).direct).toLocaleString();
        },

        timeReduction(): number {
            return 1 - this.est!.route / this.est!.direct;
        },
    },
});
